import { RESET_SERVER_STORE } from './actionTypes';

export function resetStore(storeIdentifier: string) {
  return { type: RESET_SERVER_STORE, storeIdentifier };
}
